import { IconDefinition, IconProp } from "@fortawesome/fontawesome-svg-core";
import {
  faCakeCandles,
  faChalkboardUser,
  faFileAlt,
  faLaptop,
  faPartyHorn,
  faPersonRunning,
  faTreePalm,
} from "@fortawesome/pro-solid-svg-icons";
import {
  AbsenceIcon,
  AbsenceIconMap,
} from "../redux/api-model/organization/company";
import { AbsenceTypeName } from "./absence-types";
import {
  DashboardCalendarEvent,
  DashboardCalendarEventType,
} from "../redux/api-model/dashboard-calendar";

type EventIcons = Record<DashboardCalendarEventType, IconDefinition>;

type Options = Pick<
  DashboardCalendarEvent,
  "event" | "absenceRequestType" | "absenceRequestIcon"
>;

const icons: EventIcons = {
  [DashboardCalendarEventType.BIRTHDAY]: faCakeCandles,
  [DashboardCalendarEventType.NEW_JOINER]: faChalkboardUser,
  [DashboardCalendarEventType.LEAVER]: faPersonRunning,
  [DashboardCalendarEventType.ANNIVERSARY]: faPartyHorn,
  [DashboardCalendarEventType.ABSENCE_ENDING]: faTreePalm,
  [DashboardCalendarEventType.ABSENCE_STARTING]: faTreePalm,
  [DashboardCalendarEventType.DOCUMENT_EXPIRES]: faFileAlt,
  [DashboardCalendarEventType.RETURN_INVENTORY]: faLaptop,
};

export function getResolvedIcon(item: Options): IconProp {
  if (!item.event.startsWith("ABSENCE")) {
    return icons[item.event] as IconProp;
  }

  if (item.absenceRequestType === AbsenceTypeName.SICKNESS_NAME) {
    return AbsenceIconMap[AbsenceIcon.NURSE].icon;
  }

  if (item.absenceRequestType === AbsenceTypeName.VACATION_NAME) {
    return AbsenceIconMap[AbsenceIcon.TREE_PALM].icon;
  }

  const eventIcon = item.absenceRequestIcon ?? AbsenceIcon.TREE_PALM;

  return AbsenceIconMap[eventIcon].icon;
}
